// extracted by mini-css-extract-plugin
export var fadeInOut = "_49-3";
export var icon = "_49-4";
export var savedIndicator = "_49-2";
export var savingIndicator = "_49-0";
export var spin = "_49-1";